"use client";

import Image from "next/image";
import Link from "next/link";
import { useEffect, useRef } from "react";
import Typed from "typed.js";
import { ButtonVariantTypes, getButtonVariantStylesAndSize } from "components/ui/button";

const ImageTypingText = ({
  alt,
  src,
  title,
  subtitle,
  buttonLabel,
  buttonURL,
  miniTitle,
  miniTitleTag = "h1",
  titleTag = "p",
  typedText,
  strings = []
}: {
  alt: string;
  src: string;
  title: string;
  subtitle: string;
  miniTitle: string;
  buttonLabel: string;
  buttonURL: string;
  lat?: number;
  lng?: number;
  zoom?: number;
  miniTitleTag: React.ElementType;
  titleTag: React.ElementType;
  typedText: string;
  strings: string[];
}) => {
  const TitleTag = titleTag;
  const MiniTitleTag = miniTitleTag;
  const ref = useRef(null);

  const el = useRef<HTMLDivElement | null>(null);
  const typed = useRef<Typed | null>(null);

  useEffect(() => {
    const options = {
      strings: [typedText, ...strings.filter((s) => s !== typedText)],
      loop: true,
      typeSpeed: 60,
      backSpeed: 60,
      showCursor: false
    };

    typed.current = new Typed(el.current, options);

    return () => {
      typed.current?.destroy?.();
    };
  }, [strings, typedText]);

  return (
    <section id="ImageText-8" className="intro-image relative -mt-[82px] @container">
      <div className="bnb"></div>
      <div className="min-h-80v relative h-80v w-full">
        <div className="relative h-full overflow-hidden pt-28">
          <Image
            src={src}
            alt={alt}
            fill
            priority={true}
            sizes=""
            className="absolute inset-0 -z-0 h-full w-full object-cover"
          />

          <div className="tile-container">
            <div className="relative z-30 flex h-full  max-w-screen-xl @2xl:px-8 @3xl:max-w-[1280px] @5xl:max-w-[1680px] @5xl:px-6">
              <div className="my-auto" ref={ref}>
                <MiniTitleTag className="subby !text-left !text-white">{miniTitle}</MiniTitleTag>
                <TitleTag className="pb-8 font-heading text-4xlt text-white md:whitespace-nowrap">
                  {title} <span className="typed-text  inline-block w-full" ref={el} />
                </TitleTag>
                <p className="max-w-3xl pb-6 text-md font-normal text-white [text-wrap:balance] ">{subtitle}</p>
                {buttonLabel && buttonURL ? (
                  <div className="mt-10">
                    <Link
                      className={getButtonVariantStylesAndSize({
                        variant: ButtonVariantTypes.BRAND,
                        size: "xl"
                      })}
                      href={buttonURL}
                      title={buttonLabel}
                      prefetch={false}
                    >
                      {buttonLabel}
                    </Link>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
        <div className="hero--cover realtive z-0"></div>
      </div>
    </section>
  );
};

export default ImageTypingText;
